import Instance from "./Instance";

// Get all audit logs with pagination and filtering
export const getAuditLogs = async (params = {}) => {
    try {
        const response = await Instance.get("/api/v1/auditLogs", { params });
        return response.data;
    } catch (error) {
        console.error("Error fetching audit logs:", error);
        throw error;
    }
};

// Get single audit log by ID
export const getAuditLogById = async (id) => {
    try {
        const response = await Instance.get(`/api/v1/auditLogs/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching audit log:", error);
        throw error;
    }
};

// Get all logs for a specific document
export const getDocumentAuditHistory = async (documentId) => {
    try {
        const response = await Instance.get(`/api/v1/auditLogs/document/${documentId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching document history:", error);
        throw error;
    }
};
